module.exports = __webpack_public_path__ + "static/media/exclamation-mark.fbd33943.svg";